// extracted by mini-css-extract-plugin
export default {"container":"dashboard-mobile_container__P3yte","glassBox":"dashboard-mobile_glassBox__UQSnf"};